import { IAddress } from "common/types";

type AddressProps = {
  address: IAddress;
  includeName?: boolean;
  styles?: { name?: string; address?: string; street?: string };
};

const Address = ({
  address,
  includeName = true,
  styles = { name: "", address: "", street: "" },
}: AddressProps) => {
  return (
    <div>
      {includeName && <div className={styles.name}>{address.name}</div>}
      <div className={styles.street}>{address.street}</div>
      <div className={styles.address}>
        {address.city}, {address.state} {address.zipcode}
      </div>
    </div>
  );
};

export default Address;
